import { createContext, useContext } from 'react';
export const ProductIdContext = /*#__PURE__*/createContext(undefined);
export const useProductId = () => {
  const context = useContext(ProductIdContext);
  if (context === undefined) {
    throw new Error('ProductIdContext data is undefined. useProductId must be used within a ProductIdContext.Provider');
  }
  return context;
};